import { Component, OnInit } from '@angular/core';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';
import { Router} from '@angular/router';
import { SessionCountdownService } from 'src/app/services/session-countdown/session-countdown.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-session-countdown',
  templateUrl: './session-countdown.component.html',
  styleUrls: ['./session-countdown.component.css']
})
export class SessionCountdownComponent implements OnInit {

  countdown: string | undefined;

  userInfo : UserInfo | undefined;

  constructor(private logService : LoginService, 
    private userService: UserService,
    public router: Router,
    private sessionCountdownService:SessionCountdownService,
    private toastService: ToastService) {
    
  }

  async ngOnInit() {
    //console.log("sessionconuntdown");
    /*this.userInfo = await this.logService.getUserInfo();
    await this.retriveCountDown();*/
  }

  async retriveCountDown(){
    //console.log(this.userInfo);
    let token = localStorage.getItem('access_token_einvoice') as string;
    let response = await this.userService.getSessionCountdown(token);
    if(response.success){
      this.countdown = response.data;
      //se la sessione è scaduta forzo il redirect al login
      this.sessionCountdownService.setCountdown(response.data);
      let seconds=this.sessionCountdownService.getSecondToExpire();
      if((seconds != undefined ) && (seconds <=0 )){
                  this.router.navigate(['../Login']);
      }
      
      await this.delay(60000);
      await this.retriveCountDown();
    } else {
      this.toastService.openToastWithConfig(false, 0, "Sessione scaduta", 'warning');
      this.router.navigate(['../Login']);
    }
  }

  private delay(ms: number) {
      return new Promise( resolve => setTimeout(resolve, ms) );
  }
}
